var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeftCurrentColor24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 11.9588C19 11.4237 18.5662 10.9899 18.0312 10.9899L8.30722 10.9899L10.1965 9.10006C10.5748 8.72165 10.5747 8.10822 10.1962 7.72994C9.81784 7.35165 9.20441 7.35175 8.82613 7.73017L5.28365 11.2738C4.90856 11.649 4.90503 12.2561 5.27573 12.6357L8.8182 16.2628C9.19206 16.6456 9.80544 16.6528 10.1882 16.279C10.571 15.9051 10.5783 15.2917 10.2044 14.9089L8.26928 12.9276L18.0312 12.9276C18.5662 12.9276 19 12.4938 19 11.9588Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftCurrentColor24);
export default __webpack_public_path__ + "static/media/arrow-left-currentColor-24.7fa0c43d24f32a3daa1decf96e41a46f.svg";
export { ForwardRef as ReactComponent };